import type { IDIALOGVERIFYTRANSACTIONPROPS } from 'BreetComponents';
import { type ISelectedBeneficiary } from 'BreetHelpers';
import { useCallback } from 'react';

import { useModalApi } from './useModalApi';

export const useAutoSettlementApi = (selectedBeneficiary?: ISelectedBeneficiary) => {
	const { openModalDirect } = useModalApi();

	const handleAutomaticSettlement = useCallback(() => {
		const beneficiaryId = selectedBeneficiary?.id ?? '';
		const isAutoSettlement = !!selectedBeneficiary?.autoSettlement;

		openModalDirect({
			id: 'verifyTransaction',
			metadata: {
				disableAutoSettlementReqData: {
					bankId: beneficiaryId,
				},
				updateAutoSettlementReqData: {
					bankId: beneficiaryId,
				},
				skipPin: true,
				transactionType: beneficiaryId && isAutoSettlement ? 'disableAutoSettlement' : 'updateAutoSettlement',
			} as IDIALOGVERIFYTRANSACTIONPROPS,
			variant: 'right-sheet',
		});
	}, [openModalDirect, selectedBeneficiary?.autoSettlement, selectedBeneficiary?.id]);

	return handleAutomaticSettlement;
};
